import { render, staticRenderFns } from "./ArticlesDecorsPackagingLandingPage.vue?vue&type=template&id=561917f4&scoped=true"
import script from "./ArticlesDecorsPackagingLandingPage.vue?vue&type=script&lang=js"
export * from "./ArticlesDecorsPackagingLandingPage.vue?vue&type=script&lang=js"
import style0 from "./ArticlesDecorsPackagingLandingPage.vue?vue&type=style&index=0&id=561917f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561917f4",
  null
  
)

export default component.exports